import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';

import { SmartSmsService } from 'src/app/core/api/services';
import { BaseSelectionList } from '../base/base-selection-list.component';

@Component({
    selector: 'brand-selection-list',
    templateUrl: './brand-selection-list.component.html',
    standalone: false
})
export class BrandSelectionListComponent
  extends BaseSelectionList
  implements OnInit
{
  constructor(protected currentService: SmartSmsService) {
    super();
  }

  ngOnInit() {
    this.initConfig();
    this.getItems();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'name';

    if (!this.input_label) this.input_label = 'common.deviceBrands';
  }

  getItems() {
    if (this.loading) return;
    this.loading = true;

    this.currentService
      .smartSmsGetBrands()
      .pipe(
        this.baseSelectionSearchPipeOperators,
        map((items) => {
          return items.slice(0, 200);
        })
      )
      .subscribe((items) => {
        this.items = items?.data;
      });
  }
}
